(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/prolongwager.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/prolongwager.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.ProlongWager = Backbone.Marionette.View.extend({
    tagName: 'li',
    className: 'maltipset-prolong-item',
    events: {
      'click .prolong-item-short-info': 'showExtendedInfo'
    },
    template: function(data) {
      return svs.maltipset.templates.prolongwager(data);
    },
    regions: {
      prolongList: '.prolong-item-extended-info'
    },
    showExtendedInfo: function() {
      this.$el.toggleClass('extended-info-active');
      if (!this.getRegion('prolongList').currentView) {
        this.loader =
          this.loader ||
          new svs.components.Loader(this.$el.find('.extended-info-loader'));
        this.loader.show(200, 'inverted');
        var self = this;
        this.model.getExtendedWagerInfo(
          function(model) {
            self.loader.hide();
            self
              .getRegion('prolongList')
              .show(
                new svs.maltipset.views.ProlongWagerExtended({ model: model })
              );
            self.$el.addClass('extended-info-open');
            self.$el.find('.prolong-row-item').addClass('bounce');
          },
          function() {
            self.loader.hide();
            svs.components.dialog.api.add(new svs.components.dialog.Confirm({
              branding: svs.components.dialog.branding.SPORT,
              icon: 'help-2',
              title: 'Det gick tyvärr inte att hämta spelet',
              message: [
                {
                  type: svs.components.dialog.message.TEXT,
                  text: 'Försök igen senare.'
                }
              ],
              actions: [
                {
                  title: 'OK'
                }
              ]
            }));
          }
        );
      } else {
        this.$el.toggleClass('extended-info-open');
        this.$el.find('.prolong-row-item').toggleClass('bounce');
      }
    }
  });
})(Backbone, _, svs);

 })(window);